export const directMarketingValues = ['noSolarTariff', 'stockExchange', 'fix5', 'fix10'];
